import { useEffect } from 'react';

interface MetaProps {
  title: string;
  description: string;
  url?: string;
  image?: string;
}

const Meta = ({ title, description, url = window.location.href, image }: MetaProps) => {
  useEffect(() => {
    const parsedUrl = new URL(url, window.location.origin);
    const pathname = parsedUrl.pathname === '/' ? '/' : `${parsedUrl.pathname.replace(/\/+$/, '')}/`;
    const canonicalUrl = `${parsedUrl.origin}${pathname}`;

    // 일반 메타 태그
    document.title = title;
    setMetaTag('name', 'description', description);

    // Open Graph 메타 태그
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:type', 'website');
    setMetaTag('property', 'og:url', canonicalUrl);
    if (image) {
      setMetaTag('property', 'og:image', image);
    } else {
      setMetaTag('property', 'og:image', "https://xn--o11bt07a.com/static/media/logo.2ee42c9195554c239024b933240dd3df.svg");
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);

    function setMetaTag(attr: 'name' | 'property', key: string, content: string) {
      let element = document.querySelector(`meta[${attr}="${key}"]`);
      if (element) {
        element.setAttribute('content', content);
      } else {
        const meta = document.createElement('meta');
        meta.setAttribute(attr, key);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    }
  }, [title, description, url, image]);

  return null;
};

export default Meta;
